import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { noneZeroValidator } from '../shared/validators/custom-validators.validator';
import { PercentFormatter } from '../shared/helpers/percent-formatter.helper';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable({ providedIn: 'root' })
export class OpenTrade_FormProvider {
  form: FormGroup;

  constructor(private fb: FormBuilder) {}

  initForm_ETR_Invoice_Upload(data?: any): FormGroup {
    return (this.form = this.fb.group({
      creditor: [[Validators.required]],
      originator: [data?.originator || null, [Validators.required]],
      unscheduledEtr: [data?.unscheduledEtr || ''],
      paymentDiscount: [data?.paymentDiscount || '0.000'],
      ccy: [data?.ccy || ''],
      faceValue: [data?.faceValue || '', [Validators.required]],
      unitPrice: [data?.unitPrice || '', [Validators.required]],
      remainingValue: [data?.remainingValue || '0.00'],
      vatIncluded: [data?.vatIncluded || ''],
      invoiceDate: [data?.invoiceDate || null, [Validators.required]],
      expectedDate: [data?.expectedDate || null, [Validators.required]],
      pod: [data?.pod || '', [Validators.required]],
      attachPod: [data?.attachPod || ''],
      invoiceNo: [data?.invoiceNo || '', [Validators.required]],
    }));
  }

  initForm_Revolving_ETR_Invoice_Upload(data?: any): FormGroup {
    return (this.form = this.fb.group({
      debtorId: [data?.debtorId || null],
      deliverNoA: [data?.deliverNoA || ''],
      originator: [data?.originator || null],
      disable180Days: [data?.disable180Days || ''],
      edso: [data?.edso || '', [Validators.required, Validators.max(3650)]],
      ccy: [data?.ccy || ''],
      email: [data?.email || ''],
      faceValue: [data?.faceValue || '', [Validators.required]],
      unitPrice: [data?.unitPrice || ''],
      remainingValue: [data?.remainingValue || '0.00'],
      invoiceDate: [data?.invoiceDate || null],
      expectedDate: [data?.expectedDate || null],
      pod: [data?.pod || ''],
      attachPod: [data?.attachPod || ''],
      invoiceNo: [data?.invoiceNo || ''],

      creditor: [data.creditor],
      issued: [data?.issued || ''],
    }));
  }

  initForm_Upload_PO(data?: any): FormGroup {
    return (this.form = this.fb.group({
      bEtr: [data?.bEtr || null, [Validators.required]],
      debtorId: [data?.debtorId || null],
      ccy: [data?.ccy || ''],
      PODate: [data?.PODate || null, [Validators.required]],
      faceValue: [data?.faceValue || '', [Validators.required]],
      unitPrice: [data?.unitPrice || ''],
      poNumber: [data?.poNumber || ''],
      pofile: [data?.pofile || ''],
      creditor: [],
      issued: [data?.issued || ''],
      description: [data?.description || ''],
      disable180Days: [data?.disable180Days || ''],
      noOfEtr: [data?.noOfEtr || '', [Validators.max(1200)]],
      months: [data?.months || '', [Validators.max(120)]],
    }));
  }

  initForm_OnInit(data?: any): FormGroup {
    return (this.form = this.fb.group({
      creditorId: [data?.creditorId || null],
    }));
  }

  initForm_2(data?: any): FormGroup {
    return (this.form = this.fb.group({
      creditorId: [data?.creditorId || null, [Validators.required]],
      debtorId: [data?.debtorId || null, [Validators.required]],
      edso: [data?.edso || '', [Validators.required, Validators.max(3650)]],
      ccy: [data?.ccy || '', [Validators.required]],
      faceValue: [data?.faceValue || '', [Validators.required]],
      invoiceDate: [data?.invoiceDate || null],
      expectedDate: [data?.expectedDate || null],
      deposit: [
        data?.deposit || data?.deposit === 0
          ? PercentFormatter(+data?.deposit * 100, false)
          : null,
        [Validators.min(0), Validators.max(100), Validators.required],
      ],
      rejectedMessage: [data?.rejectedMessage || ''],
    }));
  }

  initForm_A_ETR(data?: any): FormGroup {
    this.form = this.initForm_AF_ETR(data);
    this.form.addControl(
      'creditorId',
      this.fb.control(data?.creditorId || null, [Validators.required]),
    );
    return this.form;
  }

  initForm_F_ETR(data?: any): FormGroup {
    this.form = this.initForm_AF_ETR(data);
    this.form.addControl(
      'debtorId',
      this.fb.control(data?.debtorId || null, [Validators.required]),
    );
    return this.form;
  }

  private initForm_AF_ETR(data?: any): FormGroup {
    const today = new Date();
    const nextYear = new Date(today);
    nextYear.setFullYear(today.getFullYear() + 1);

    return this.fb.group({
      ccy: [data?.ccy || '', [Validators.required]],
      issuedDate: [
        this.toNgbDate(data?.issuedDate) || null,
        [Validators.required],
      ],
      deposit: [
        data?.deposit || data?.deposit === 0
          ? PercentFormatter(+data?.deposit * 100, false)
          : null,
        [Validators.min(0), Validators.max(100), Validators.required],
      ],
      faceValue: [
        data?.faceValue || '',
        [Validators.required, noneZeroValidator()],
      ],
      unitPrice: [
        data?.unitPrice || '',
        [Validators.required, noneZeroValidator()],
      ],
      months: [
        data?.months || '',
        [Validators.required, Validators.max(120), noneZeroValidator()],
      ],
      rejectedMessage: [data?.rejectedMessage || ''],
    });
  }

  initForm_B_ETR(data?: any): FormGroup {
    this.form = this.init_BCD_ETR(data);
    this.form.addControl(
      'creditorId',
      this.fb.control(data?.creditorId || null, [Validators.required]),
    );
    return this.form;
  }

  initForm_C_ETR(data?: any): FormGroup {
    this.form = this.init_BCD_ETR(data);
    this.form.addControl(
      'creditorId',
      this.fb.control(data?.creditorId || null, [Validators.required]),
    );
    return this.form;
  }

  initForm_D_ETR(data?: any): FormGroup {
    this.form = this.init_BCD_ETR(data);
    this.form.addControl(
      'debtorId',
      this.fb.control(data?.debtorId || null, [Validators.required]),
    );
    return this.form;
  }

  private init_BCD_ETR(data?: any): FormGroup {
    return this.fb.group({
      edso: [data?.edso || '', [Validators.required, Validators.max(3650)]],
      ccy: [data?.ccy || '', [Validators.required]],
      faceValue: [data?.faceValue || '', [Validators.required]],
      noOfEtr: [
        data?.noOfEtr || '',
        [Validators.required, Validators.max(1200)],
      ],
      months: [data?.months || '', [Validators.required, Validators.max(120)]],
      description: [data?.description || ''],
      rejectedMessage: [data?.rejectedMessage || ''],
    });
  }

  private toNgbDate(dateString: string): NgbDateStruct | null {
    if (!dateString) return null;
    const [y, m, d] = dateString.split('-').map(Number);
    return { year: y, month: m, day: d };
  }
}
